import { render } from "./ContactMe.vue?vue&type=template&id=5b989af5&scoped=true"
const script = {}

import "./ContactMe.vue?vue&type=style&index=0&id=5b989af5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b989af5"]])

export default __exports__